import { useQuery } from '@tanstack/react-query';
import { get } from '../api';

export const usePlans = () => {
  const { data, isFetching } = useQuery(
    ['plans'],
    () => get('/api/client_admin/plans'),
    {
      refetchOnWindowFocus: false,
      initialData: {
        plans: {
          broadcast: false,
          reports: false,
          users: false,
          campaigns: false,
          campaignInfo: {
            canMakeCampaignLive: false,
            unlimitedCampaigns: false,
            campaignLimit: 0,
            remainingCampaignCount: 0,
          },
          audienceInfo: {
            canAddAudience: false,
            audienceLimit: 0,
            remainingAudienceCount: 0,
          },
        },
      },
    },
  );

  return { ...data, isFetching };
};
